export const FirebaseConfig = {
	"projectId": "fleetflow-c7a09",
	"appId": "1:49728824247:web:7cc3d009c159e8df0ffe32",
	"databaseURL": "https://fleetflow-c7a09-default-rtdb.europe-west1.firebasedatabase.app",
	"storageBucket": "fleetflow-c7a09.appspot.com",
	"locationId": "europe-west3",
	"apiKey": "AIzaSyDQb5Vvwpvg6KHN5Sq4BiXbUx56gM4eA9E",
	"authDomain": "fleetflow-c7a09.firebaseapp.com",
	"messagingSenderId": "49728824247",
	"measurementId": "G-MQS6FST02E",
	"projectNumber": "49728824247",
	"version": "2"
};